import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Configure axios to always send credentials (cookies)
axios.defaults.withCredentials = true;

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null); // Keep for API compatibility, but token is now in HttpOnly cookie
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuthData = async () => {
      // Get selected org from localStorage (org selection is not sensitive)
      const selectedOrg = JSON.parse(localStorage.getItem("selectedOrg"));

      if (selectedOrg) {
        try {
          // Token is automatically sent via HttpOnly cookie
          const response = await axios.get(
            `${process.env.REACT_APP_API}/api/auth/verify/${selectedOrg}`
          );
          
          setAuthToken(true); // Indicate authenticated (actual token is in cookie)
          setUserData(response.data.userInfo);
          setOrgData(response.data.orgInfo);
        } catch (error) {
          console.error("Token verification failed:", error);
          // Clear localStorage on auth failure
          localStorage.removeItem("selectedOrg");
          setAuthToken(null);
        }
      }

      setLoading(false);
    };

    fetchAuthData();
  }, []);

  const logout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/api/auth/logout`);
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear local state and storage
      setAuthToken(null);
      setUserData(null);
      setOrgData(null);
      localStorage.removeItem("selectedOrg");
      navigate("/login");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <AuthContext.Provider
      value={{
        authToken,
        userData,
        orgData,
        setAuthToken,
        setUserData,
        setOrgData,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
